import { jsx as _jsx } from "react/jsx-runtime";
import { LayoutDetail } from "../detail";
export var GridEditor = function (_a) {
    var layoutName = _a.layoutName, packageName = _a.packageName, moduleName = _a.moduleName;
    return (_jsx("div", { children: _jsx(LayoutDetail, { layoutName: layoutName, packageName: packageName, moduleName: moduleName }) }));
};
